import React from "react";

import logo from "../../../../../images/logo.ico"; // for the logo in the header

import classes from "./Navigation.module.css";
import scrollClasses from "../../../../classes/ContainerClassesMobile"
//this component is for the navigation buttons
// TODO: add the functionality of each button to scroll to destination

const Navigation = () => {
  const scrollToOurWork = () => {
    const element = document.getElementsByClassName(scrollClasses.OurWorkContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const scrollToOurCenters = () => {
    const element = document.getElementsByClassName(scrollClasses.MapContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const scrollToGiving = () => {
    const element = document.getElementsByClassName(scrollClasses.GivingContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const scrollToFacts = () => {
    const element = document.getElementsByClassName(scrollClasses.FactsNFIguresContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const scrollToCareers = () => {
    const element = document.getElementsByClassName(scrollClasses.FooterContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <div className={classes.container}>
      <div className={classes.left}>
        <img src={logo} alt="logo" className={classes.logo+" "+classes.link} />
      </div>
      <div className={classes.right}>
        <div className={classes.link} onClick={scrollToOurWork}>Our Work</div>
        <div className={classes.link} onClick={scrollToOurCenters}>Our Centers</div>
        <div className={classes.link} onClick={scrollToGiving}>Giving</div>
        <div className={classes.link} onClick={scrollToFacts}>Facts & Figures</div>
        <div className={classes.link} onClick={scrollToCareers}>Careers</div>
      </div>
    </div>
  );
};
export default Navigation;
